import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Brands from "@/pages/Brands";
import People from "@/pages/People";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Proof from "@/pages/Proof";
import About from "@/pages/About";
import Legal from "@/pages/Legal";
import Join from "@/pages/Join";
import CampaignStart from "@/pages/CampaignStart";
import Wallet from "@/pages/Wallet";
import ParticipantLogin from "@/pages/ParticipantLogin";
import VerifyEmail from "@/pages/VerifyEmail";
import PasswordReset from "@/pages/PasswordReset";
import { CookieConsent } from "@/components/CookieConsent";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
      }, 100);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/people" element={<People />} />
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/nachweis/:id" element={<Proof />} />
          <Route path="/join" element={<Join />} />
          <Route path="/start" element={<CampaignStart />} />
          <Route path="/registrieren" element={<Navigate to="/people#register" replace />} />
          <Route path="/register" element={<Navigate to="/people#register" replace />} />
          <Route path="/konto" element={<Wallet />} />
          <Route path="/konto/login" element={<ParticipantLogin />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/passwort-reset" element={<PasswordReset />} />
          <Route path="/about" element={<About />} />
          <Route path="/impressum" element={<Legal type="impressum" />} />
          <Route path="/datenschutz" element={<Legal type="datenschutz" />} />
          <Route path="/agb" element={<Legal type="agb" />} />
        </Routes>
        <CookieConsent />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
